import { render, staticRenderFns } from "./time-widget.vue?vue&type=template&id=2e1ca6f9&scoped=true"
import script from "./time-widget.vue?vue&type=script&lang=js"
export * from "./time-widget.vue?vue&type=script&lang=js"
import style0 from "./time-widget.vue?vue&type=style&index=0&id=2e1ca6f9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1ca6f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e1ca6f9')) {
      api.createRecord('2e1ca6f9', component.options)
    } else {
      api.reload('2e1ca6f9', component.options)
    }
    module.hot.accept("./time-widget.vue?vue&type=template&id=2e1ca6f9&scoped=true", function () {
      api.rerender('2e1ca6f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/field-widget/time-widget.vue"
export default component.exports